
<div class="px-ogs relative">
  
  <div class="swiper-button-container">
    <button
      class="swiper-button"
      :class="theme === 'dark' ? 'swiper-button--white' : ''"
      @click="prev"
    >
      <div class="swiper-button__inner">&larr;</div>
    </button>
  </div>

  <swiper :options="swiperOptions" ref="swiper">
  <SwiperSlide v-for="product in products" :key="product.id">
    <slot :name="'product-' + product.id">
    </slot>
  </SwiperSlide>
</swiper>

  <div class="swiper-button-container">
    <button
      class="swiper-button"
      :class="theme === 'dark' ? 'swiper-button--white' : ''"
      @click="next"
    >
      <div class="swiper-button__inner">&rarr;</div>
    </button>
  </div>
</div>
